import React from 'react';
import Icon from './Icon';

interface KpiCardProps {
  icon: string;
  label: string;
  value: string;
  change: string;
  up: boolean;
  onClick?: () => void;
  delay?: number;
}

const KpiCard: React.FC<KpiCardProps> = ({
  icon,
  label,
  value,
  change,
  up,
  onClick,
  delay = 0,
}) => (
  <div
    className="card flex-1 min-w-[220px] p-6 cursor-pointer animate-fadeIn"
    style={{ animationDelay: `${delay}ms` }}
    onClick={onClick}
  >
    <div className="flex justify-between items-start mb-3">
      <div
        className="w-11 h-11 rounded-xl flex items-center justify-center"
        style={{ background: 'var(--brand-bg)' }}
      >
        <Icon name={icon} size={22} color="var(--brand)" />
      </div>
      <span
        className="flex items-center gap-1 text-[13px] font-semibold"
        style={{ color: up ? 'var(--green)' : 'var(--red)' }}
      >
        <Icon
          name={up ? 'trending-up' : 'trending-down'}
          size={14}
          color={up ? 'var(--green)' : 'var(--red)'}
        />
        {change}
      </span>
    </div>
    <div className="text-[28px] font-bold text-ink leading-tight">{value}</div>
    <div className="text-[13px] text-g500 mt-1 font-medium">{label}</div>
  </div>
);

export default KpiCard;
